import { RouteObject } from "react-router-dom";
import BannerListPage from "@/pages/banners/BannerListPage";
import BannerDetailPage from "@/pages/banners/BannerDetailPage";

export const bannerRoutes: RouteObject[] = [
  {
    path: "/notices",
    children: [
      {
        index: true,
        element: <BannerListPage />,
      },
      {
        path: ":id",
        element: <BannerDetailPage />,
      }
    ],
  },
];
